import {
  GetMailTemplateListConst,
  GetScheduleSendMailUsing365ListConst,
  GetSentMailListConst,
  ReplyEmailPayload,
} from "../constant/EmailConstant";

const initTheme = {
  email: [],
  sentemail: [],
  emailTemplate: [],
  ReplyEmailPayload:null
};

const EmailReducer = (state = initTheme, action) => {

  switch (action.type) {
    case GetScheduleSendMailUsing365ListConst: {
      const payload = action.payload;
      if (Array.isArray(payload)) {
        return { ...state, email: payload };
      }
      if (payload?.data && Array.isArray(payload.data)) {
        return { ...state, email: payload };
      }
      return { ...state, email: payload };
    }
    case GetSentMailListConst:
      return { ...state, sentemail: action.payload };

    case GetMailTemplateListConst:
      return { ...state, emailTemplate: action.payload };
    
    case ReplyEmailPayload:
      return { ...state, ReplyEmailPayload: action.payload};

    default:
      return state;
  }
};

export default EmailReducer;
